import * as React from 'react';

import useBeamer from 'redesign/hooks/useBeamer';

interface BeamerManagerProps {
    children: React.ReactNode;
}

function BeamerManager({ children }: BeamerManagerProps) {
    useBeamer();
    return <React.Fragment>{children}</React.Fragment>;
}

export default BeamerManager;
